import * as React from 'react';

function LoadingIndicator({ fill = '#ffffff', ...rest }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={32} height={32} viewBox="0 0 128 128" data-testid="loading-indicator" {...rest}>
      <rect x="0" y="0" width="100%" height="100%" fill={fill} />
      <g>
        <path d="M59.6 0h8v40h-8V0z" fill="#0095ff" fillOpacity="1" />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#cceaff"
          fillOpacity="0.2"
          transform="rotate(30 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#cceaff"
          fillOpacity="0.2"
          transform="rotate(60 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#cceaff"
          fillOpacity="0.2"
          transform="rotate(90 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#cceaff"
          fillOpacity="0.2"
          transform="rotate(120 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#b2dfff"
          fillOpacity="0.3"
          transform="rotate(150 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#99d5ff"
          fillOpacity="0.4"
          transform="rotate(180 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#7fcaff"
          fillOpacity="0.5"
          transform="rotate(210 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#66bfff"
          fillOpacity="0.6"
          transform="rotate(240 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#4cb5ff"
          fillOpacity="0.7"
          transform="rotate(270 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#33aaff"
          fillOpacity="0.8"
          transform="rotate(300 64 64)"
        />
        <path
          d="M59.6 0h8v40h-8V0z"
          fill="#199fff"
          fillOpacity="0.9"
          transform="rotate(330 64 64)"
        />
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64"
          calcMode="discrete"
          dur="1080ms"
          repeatCount="indefinite"
        ></animateTransform>
      </g>
    </svg>
  );
}

export default LoadingIndicator;
